module.exports = __webpack_public_path__ + "static/paymentOrchestIndex_fr-4494657932afd2cb879eed19ab501e9e.png";